import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import AppRoute from "./route/AppRoute";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";


function App() {
  const { i18n } = useTranslation();
  const [dir, setDir] = useState(i18n.language === "ar" ? "rtl" : "ltr");

  useEffect(() => {
    const saved = localStorage.getItem("lang") || "en";
    i18n.changeLanguage(saved);
  },[i18n]);
  useEffect(() => {
    const nextDir = i18n.language === "ar" ? "rtl" : "ltr";
    setDir(nextDir);
    document.documentElement.dir = nextDir;
     document.body.className = nextDir;
  }, [i18n.language]);
 

  return (
    <BrowserRouter>
      <ConfigProvider direction={dir}>
        <AppRoute />
      </ConfigProvider>
    </BrowserRouter>
  );
}

export default App;
